import React from 'react';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/mode-scala';

interface AceScriptEditorProps {
  value: string;
  onChange: (value: string) => void;
  height?: string;
  readOnly?: boolean;
  name?: string;
  onBlur?: () => void;
  placeholder?: string;
}

const AceScriptEditor: React.FC<AceScriptEditorProps> = ({
  value,
  onChange,
  height = '400px',
  readOnly,
  name,
  onBlur,
  placeholder,
}) => {
  return (
    <AceEditor
      mode='scala'
      theme='tomorrow'
      value={value}
      onChange={onChange}
      name={name || 'ace-script-editor'}
      width='100%'
      height={height}
      fontSize={14}
      setOptions={{
        useWorker: false,
        showLineNumbers: true,
        tabSize: 2,
        wrap: true,
      }}
      readOnly={readOnly}
      onBlur={onBlur}
      placeholder={placeholder}
    />
  );
};

export default AceScriptEditor;
